'use strict';

import {Component, Inject, Input, OnInit} from 'ng-metadata/core';
import {PrimolyticsService, beacon} from '../../../analytics/primolytics.service';
import {IStateParamsService} from 'angular-ui-router';
import {EndlessScrollingUtil} from "../../../nddUtils/endlessScollingUtil.service";
import {LoginService} from "../../../security/login/login.service";
import {QrCodeService} from "./qrCode.service";
import {PermalinkService} from '../../actions/permalinkAction/permalink.service';
import {MediaQueries} from "../../../infra/mediaQueries.service";

const he = require('he');
let qrcode = require('qrcode');


@Component({
    selector: 'prm-qr-code',
    templateUrl: 'components/search/topbar/qrCode/qr-code.html'
})


export class PrmQrCode implements OnInit {
        
    private buttonText;
    private copySuccessful = false;
    private copySuccessfulImage = false;
    private COPIED_TEXT: string;
    private SAFARI_COPIED_TEXT: string;
    private DISPLAY_TEXT: string;
    private SAFARI_DISPLAY_TEXT: string;
    private FAILURE_TEXT: string;
    private offset: number;
    private scrollContainer: HTMLElement;
    private qrUiHtml: Object;
    private qrImageSrc: string;
    private qrImageId: string;
    private qrUrl: string;
    @Input() public text: string;
    @Input() private action: string;
    @Input() public selectedIds: Object;
    @Input() private item: any;
    @Input() public uiType: Object;
    private _showCopyImageButton: boolean = false;

    constructor(@Inject('$mdDialog') private $mdDialog: ng.material.IDialogService,
                @Inject('loginIcons') public loginIcons,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('$location') private $location: ng.ILocationService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$state') private $state: ng.ui.IStateService,
                private permalinkService: PermalinkService,
                private endlessScrollingUtil: EndlessScrollingUtil,
                private qrCodeService: QrCodeService,
                private mediaQueries: MediaQueries) {
        
        this.qrUiHtml = {
            dialog: 'components/search/topbar/qrCode/qr-code-dialog.html',
            action: 'components/search/topbar/qrCode/qr-code-action.html'
        };
    }

    ngOnInit() {
        if (this.uiType === 'dialog') {
             this.qrUrl = window.location.href;
             this.qrImageId = 'qr_code_img_dialog';
             this.setQrImageSrc();
             this.sendQrCodeBeacon();
        }
        else if(this.$state.current.name === "servicesPage"){
            this.qrUrl = window.location.href;
            this.qrImageId = 'qr_code_img_actions';
            this.setQrImageSrc();
        }
        else {
             this.qrImageId = 'qr_code_img_actions';
             this.permalinkService.getPermalink(this.item, null).then((response) => {
                 if(response && response.data.permalink){
                     this.qrUrl = response.data.permalink + '&lang=' + this.$translate.use();
                     this.setQrImageSrc();
                 }
             });
        }
    }

    public getQrHtml() {
        if (!this.uiType || !this.qrUiHtml[this.uiType]) {
            return this.qrUiHtml['dialog']; //default
        }
        return this.qrUiHtml[this.uiType];
    }

    // Image copy button
    private clipboardSuccessImage() {
        this.displayTemporaryTextImage(this.isSupportedImage ? this.COPIED_TEXT : this.SAFARI_COPIED_TEXT);
        this.copySuccessfulImage = true;
        this.endlessScrollingUtil.enableSearchEndlessScrolling();
    }

    private clipboardFailureImage(err) {
        this.displayTemporaryTextImage(this.FAILURE_TEXT);
        console.error("Clipborad error!", err);
        this.endlessScrollingUtil.enableSearchEndlessScrolling();
    }

    private displayTemporaryTextImage(txt) {
        this.buttonText = txt;
        this.$timeout(() => {
            this.buttonText = this.isSupportedImage ? this.DISPLAY_TEXT : this.SAFARI_DISPLAY_TEXT;
            this.copySuccessfulImage = false;
        }, 4000);
    }

    get isSupportedImage() {
        let w = window as any;
        return !(Object.prototype.toString.call(w.HTMLElement).indexOf('Constructor') > 0); //return false if browse is safari
        //return this.clipboard.supported;
    }

    // Link copy button
    private clipboardSuccess() {
        this.displayTemporaryText(this.isSupported ? this.COPIED_TEXT : this.SAFARI_COPIED_TEXT);
        this.copySuccessful = true;
        this.endlessScrollingUtil.enableSearchEndlessScrolling();
    }

    private clipboardFailure(err) {
        this.displayTemporaryText(this.FAILURE_TEXT);
        console.error("Clipborad error!", err);
        this.endlessScrollingUtil.enableSearchEndlessScrolling();
    }

    private displayTemporaryText(txt) {
        this.buttonText = txt;
        this.$timeout(() => {
            this.buttonText = this.isSupported ? this.DISPLAY_TEXT : this.SAFARI_DISPLAY_TEXT;
            this.copySuccessful = false;
            (this.uiType === 'dialog') ? this.qrCodeService.setFocusOnElement('closeQrCodeDialog', true) : this.qrCodeService.setFocusOnElement('#QR button', false);
        }, 4000);
    }

    get isSupported() {
        let w = window as any;
        return !(Object.prototype.toString.call(w.HTMLElement).indexOf('Constructor') > 0); //return false if browse is safari
        //return this.clipboard.supported;
    }

    public cancelQrCopy() {
        this.qrCodeService.removeBackgroundDarkClass();
        this.$mdDialog.cancel();

        if (this.uiType === 'dialog') {
            document.querySelector('#qrCodeScanner').focus();
        } else {
            document.querySelector('#QR button').focus();
        }
    }

    public setQrImageSrc(){
         qrcode.toDataURL(this.qrUrl).then(src_qr_code => {
             this.qrImageSrc = src_qr_code;
         });
    }
    
    private sendQrCodeBeacon() {
        this.qrCodeService.sendQrCodeBeacon();
    }

    public copyQrUrlToClipboard() {
        this.qrCodeService.copyQrUrlToClipboard(this.qrUrl);
    }

    public copyQrImageToClipboard() {
        this.qrCodeService.copyQrImageToClipboard(this.qrImageId);
    }

    get qrImageSrc(){
        return this._qrImageSrc;
    }

    set qrImageSrc(qrImageSrc){
        return this._qrImageSrc = qrImageSrc;
    }

    get qrUrl(){
        return this._qrUrl;
    }

    set qrUrl(qrUrl){
        return this._qrUrl = qrUrl;
    }

    get qrImageId(){
        return this._qrImageId;
    }

    set qrImageId(qrImageId){
        return this._qrImageId = qrImageId;
    }

    get showCopyImageButton(){
        return this._showCopyImageButton;
    }

    set showCopyImageButton(showCopyImageButton){
        return this._showCopyImageButton = showCopyImageButton;
    }

    get UrlToCopy(){
        return this.qrUrl; // he.decode(this.qrUrl ? String(this.qrUrl).replace(/<[^>]+>/gm, '') : '');
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/topbar/qrCode/qrCode.directive.ts